import { qualificationType } from "../shared/data-leads"

export const FunctionEmployeeDetail = (leads: qualificationType) => {
    let error = 0
    let errorMessage = ""

    if(leads.Occupation && leads.Occupation.length > 0){
        error = 0
    } else {
        if (errorMessage.length > 0) {
            errorMessage += ", "
        }
        errorMessage += "Please Enter Occupation"
        error = 1
    }

    if(leads.Employer && leads.Employer.length > 0){
        error = 0
    } else {
        if (errorMessage.length > 0) {
            errorMessage += ", "
        }
        errorMessage += "Please Enter Employer"
        error = 1
    }

    if(leads["Mode of Employment"] && leads['Mode of Employment'].length > 0){
        error = 0
    } else {
        if (errorMessage.length > 0) {
            errorMessage += ", "
        }
        errorMessage += "Please Select Mode of Employment"
        error = 1
    }
    if(leads["Length of Employment"] && leads['Length of Employment'].length > 0){
        error = 0
    } else {
        if (errorMessage.length > 0) {
            errorMessage += ", "
        }
        errorMessage += "Please Enter Length of Employment"
        error = 1
    }
    
    if(leads["Wages Payment"] && leads["Wages Payment"].length > 0) {
        error = 0
    } else {
        if (errorMessage.length > 0) {
            errorMessage += ", "
        }
        errorMessage += "Please Choose Wages Payment"
        error = 1
    }
    
    return {
        error: error,
        errorMessage: errorMessage
    }
}